export default __webpack_public_path__ + "static/media/ShiftWise-Graph-Icon.ddade179.svg";